
import { useState, useEffect } from "react";
import { format } from "date-fns";
import { getGeneralTypes, postDataResponse } from "./Services";
import { StyledSelect, InputContainer, InputWrapper, HeaderContainer, HeaderText, NoteField, GreyButton, RedButton, RightJustifyDiv, SubmitSpan, styleButtonCalltoaction } from "./Style";
import { useMsal, useMsalAuthentication } from "@azure/msal-react";

import { Grid, TextField, Backdrop, Button, Card, CircularProgress, CardContent, CardHeader, Typography, InputLabel, MenuItem, FormControl, Select } from '@mui/material/';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useNavigate } from 'react-router-dom';
import ConfirmDialog from "./ConfirmDialog";

const SigCaseDevForm = ({ onSave, Case = {} }) => {
  const [MatterID, setMatterID] = useState([]);
  const [CaseType, setCaseType] = useState([]);
  const [errorRequest, setErrorRequest] = useState(false);
  const [selectedValueMatterID, setSelectedValueMatterID] = useState("");
  const [selectedCaseType, setSelectedCaseType] = useState("");
  const [CalValue, SetCalValue] = useState(new Date());
  const [userEmail, setUserEmail] = useState('');
  const [notesVal, setNotes] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const { instance, accounts } = useMsal();
  const [openDialog, setOpenDialog] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [dialogMessage, SetDialogMessage] = useState("");
  const [isUploading, setUploading] = useState(false);
  const [dialogDestUrl, setDialogDestUrl] = useState("");

  useEffect(() => {
    async function fetchInitialData(_email) {
      //Matter ID dropdown

      const currentAccount = instance.getActiveAccount() || accounts[0];
      var body = {};
      if (currentAccount) {
        setUserEmail(currentAccount.username);  //(currentAccount.username);
        body.email = currentAccount.username; //currentAccount.username;
      }
      const accessTokenRequest = {
        scopes: ["User.Read"],
        account: currentAccount,
      };
      const matterIDResponse = await postDataResponse('/User/MatterList', body);  //await getMatterID(body.email);
      matterIDResponse.errors ? setErrorRequest(true) : setMatterID(matterIDResponse.data);

      
      //Case Type dropdown
      const caseTypeResponse = await getGeneralTypes('/Settings/SignificateDateTypes');
      caseTypeResponse.errors ? setErrorRequest(true) : setCaseType(caseTypeResponse);
    }


    fetchInitialData();
  }, [instance, userEmail]);



  const handleSelectChangeMatterID = (event) => {
    setSelectedValueMatterID(event.target.value);



  };

  const handleSelectCaseType = (event) => {
    setSelectedCaseType(event.target.value);

  };


  async function handleSubmit(e) {
    e.preventDefault();
    setUploading(true);
    // Read the form data
    const form = e.target;
    const formData = new FormData(form);

    const formJson = Object.fromEntries(formData.entries());

    let _ctype = formJson.CaseTypeSelect;
    let _mID = formJson.MatterIDSelect;
    let _notes = formJson.textNotes;

    let postObject = {
      eMail: userEmail,
      matterID: _mID,
      type: _ctype,
      enteredDate: format(CalValue.$d, "MM/dd/yyyy"),
      note: _notes
    };


    postDataResponse('/Matter/SignificateDate', postObject).then((response) => {
      setUploading(false);
      if (response.status === 200 || response.status === 201) {
        setIsSuccess(true);

        SetDialogMessage("Significant Case Development was Successfully Submitted");
      }
      else {
        setIsSuccess(false);
        SetDialogMessage(response.data);
      }
      setOpenDialog(true);
    });
  };

  const handleCloseDialog = () => { setOpenDialog(false); };
  return (
    <form method="post" onSubmit={handleSubmit}>
      <div>
        <Card className="form-card">
          <CardHeader title="Submit Significant Case Development" style={{ backgroundColor: "#8B0E04", color: "#fff" }} />
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <FormControl fullWidth margin="normal">
                  <InputLabel id="MatterIDSelectLbl">Matter ID</InputLabel>
                  <Select
                    name="MatterIDSelect"
                    labelId="MatterIDSelectLbl"
                    id="MatterIDSelect"
                    value={selectedValueMatterID}
                    label="Matter ID"
                    onChange={handleSelectChangeMatterID}
                    required>
                    <MenuItem value="">Choose a Matter</MenuItem >
                    {MatterID !== null ? MatterID.map((value) => (
                      <MenuItem key={value.id} value={value.id}>
                        {"\"" + value.id + "\" - " + value.description + " - " + value.clientSort}
                      </MenuItem >
                    )) : <MenuItem ></MenuItem >}
                  </Select>
                </FormControl>
              </Grid>
              <Grid xs={12} sm={6} item>
                <FormControl fullWidth margin="normal">

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Date Entered"
                      name="SigCaseDate"
                      onChange={(newValue) => { SetCalValue(newValue); setIsValid(true); }} value={dayjs('CalValue')}
                      defaultValue={new Date()}
                      slotProps={{
                        textField: {
                          required: true,
                        },
                      }} />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth margin="normal">
                  <InputLabel id="TypeLbl">Type</InputLabel>
                  <Select
                    labelId="TypeLbl"
                    id="Type"
                    value={selectedCaseType}
                    label="TypeLbl"
                    name="CaseTypeSelect"
                    onChange={handleSelectCaseType}
                    required
                  >
                    <MenuItem value="">Choose a Type</MenuItem >
                    {CaseType.map((value) => (
                      <MenuItem key={value.Key} value={value.Key}>
                        {value.Value}
                      </MenuItem >
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid xs={12} item>
                <TextField
                  name="textNotes"
                  label="Notes" variant="outlined" margin="normal"
                  multiline
                  rows={5}
                  maxRows={15}
                  value={notesVal}
                  onChange={e => setNotes(e.target.value)}
                  required
                  fullWidth
                  placeholder="Notes"

                />
              </Grid>



              <Grid item xs={12} sm={6}>
                <Button type="submit" variant="contained" color='success' fullWidth>Submit</Button>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Button type="reset" variant="contained" value="Reset" fullWidth color='secondary' >Clear</Button>
              </Grid>

            </Grid>
          </CardContent>
        </Card>
        <Backdrop
          sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
          open={isUploading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
      <ConfirmDialog
        isOpen={openDialog}
        onClose={handleCloseDialog}
        isSuccess={isSuccess}
        message={dialogMessage}
        destination={dialogDestUrl}
      />
    </form>
  );
};
export default SigCaseDevForm;
